import { Spinner, SpinnerColor } from '@lili/lili-frontend-common';

export const GeneralSpinner = () => (
  <Spinner spinnerColor={SpinnerColor.Blue} width='32px' height='32px' />
);
